/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
var routes = [
  {
    exact: true,
    path: "/",
    name: "登録済点検一覧",
    group: "all",
  },
  {
    exact: false,
    path: "/settings",
    name: "設定",
    group: "Admin"
  }
];
export default routes;
